import gql from 'graphql-tag';

const GET_DEMOGRAPH_AUDIENCE_STATUS = gql`
  query getDemographAudienceStatus($audienceDemographId: ID!) {
    getDemographAudienceStatus(audienceDemographId: $audienceDemographId) {
      audienceDemographId
      audienceId
      isPushedToS3MJ
      isPushedToS3Statara
      isPublished
      status
      message
      synced
    }
  }
`;

export default GET_DEMOGRAPH_AUDIENCE_STATUS;
